import { render, staticRenderFns } from "./PaginaBilancioProduzioni.vue?vue&type=template&id=705c2ed1"
import script from "./PaginaBilancioProduzioni.vue?vue&type=script&lang=js"
export * from "./PaginaBilancioProduzioni.vue?vue&type=script&lang=js"
import style0 from "./PaginaBilancioProduzioni.vue?vue&type=style&index=0&id=705c2ed1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports